import React, { useEffect, useState, useRef } from 'react';
import { numberFormat } from '../../../Utils';
import { ArrowLongDownIcon, ArrowLongUpIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/solid';
import { getTransactionList, exportTransactionList } from '../../../api/DashboardInteractor';
import { ArrowDownCircleIcon, ArrowDownIcon } from '@heroicons/react/20/solid';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { format } from 'date-fns';

function TransactionList(props) {


  const columns = [

    { label: "Jenis Olahraga", accessor: "sport_type" },
    { label: "Nama Lapang", accessor: "venue_name" },
    { label: "PIC Name", accessor: "pic_name" },
    { label: "Tanggal Booking", accessor: "booking_date" },
    { label: "Jam Booking", accessor: "booking_time" },
    { label: "Total Transaksi", accessor: "total" },
    { label: "Status", accessor: "status" }

  ]

  let [sortField, setSortField] = useState("venueName")
  let [sortOrder, setSortOrder] = useState("asc")
  let [transactionList, setTransactionList] = useState([])

  let [filteredTransaksi, setFilteredTransaksi] = useState([])
  let [pagination, setPagination] = useState([])

  let [query, setQuery] = useState("")
  let [filter, setFilter] = useState("")
  let [date, setDate] = useState("")
  let [endDate, setEndDate] = useState("")
  const selectRef = useRef(null);

  let [exportPage, setExportPage] = useState(1);
  let [exportData, setExportData] = useState([]);
  let [addedData, setAddedData] = useState([]);

  const handleSortingChange = (accessor) => {
    const sortOrderTemp =
      accessor === sortField && sortOrder === "asc" ? "desc" : "asc";
    setSortField(accessor)
    setSortOrder(sortOrderTemp)

    handleSorting(accessor, sortOrderTemp);
  }

  const handleSorting = (sortField, sortOrder) => {
    if (!sortField) return;

    const sorted = [...transactionList].sort((a, b) => {
      let aValue, bValue;

      if (sortField === "booking_date" || sortField === "booking_time") {
        // Get the earliest booking_date for each item
        aValue = a.booking_times.length ? a.booking_times[0].booking_date : null;
        bValue = b.booking_times.length ? b.booking_times[0].booking_date : null;

        // Sort null/undefined/empty values last
        if (aValue == null) return 1;
        if (bValue == null) return -1;

        if (aValue !== bValue) {
          return (aValue.localeCompare(bValue, "en", { numeric: true }) * (sortOrder === "asc" ? 1 : -1));
        }

        // If booking_date is the same, sort by booking_time
        aValue = a.booking_times.length ? a.booking_times[0].booking_time : null;
        bValue = b.booking_times.length ? b.booking_times[0].booking_time : null;

        if (aValue == null) return 1;
        if (bValue == null) return -1;
      } else {
        aValue = a?.[sortField] ?? null;
        bValue = b?.[sortField] ?? null;

        if (aValue == null) return 1;
        if (bValue == null) return -1;
      }

      return aValue.toString().localeCompare(bValue.toString(), "en", { numeric: true }) * (sortOrder === "asc" ? 1 : -1);
    });

    setFilteredTransaksi(sorted);
  };




  const getTransactionListApi = (newFilter) => {
    let finalFilter = ""
    if (newFilter === "") {
      finalFilter = filter
    } else {
      if (newFilter === "all") {
        finalFilter = ""
      } else {
        finalFilter = newFilter
      }
    }
    getTransactionList(1, query, finalFilter, date, endDate,
      //success
      (responseJSON) => {
        setTransactionList(responseJSON.transactions)
        setFilteredTransaksi(responseJSON.transactions)
        setPagination(responseJSON.pagination)
      },
      //failed
      () => {

      }
    )
  }

  const filterTransactionStatus = (status) => {

    setFilter(status)
    getTransactionListApi(status)

  }


  const handleQueryEnter = () => {
    getTransactionListApi("")

  }

  const handleClickPage = (page) => {
    getTransactionList(page, query, filter, date, endDate,
      //success
      (responseJSON) => {
        setTransactionList(responseJSON.transactions)
        setFilteredTransaksi(responseJSON.transactions)
        setPagination(responseJSON.pagination)
      },
      //failed
      () => {

      }
    )

  }

  useEffect(() => {
    getTransactionListApi("")
  }, [])

  useEffect(() => {
    getTransactionListApi("")
  }, [date, endDate])
  const exportDataToExcel = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    let headers = {
      clientkey: "f92472dd39235f7c1b183685c509ad13"
    };

    try {
      const params = {
        page: 1,
        search: query,
        filter: filter,
        sort_by: "booking_date",
        sort_direction: "asc",
        start_date: date,
        end_date: endDate,
        auth_token: user.auth_token
      };

      const config = {
        method: "GET",
        url: process.env.REACT_APP_TRANSACTION_EXPORT,
        params: params,
        headers: headers,
        responseType: "blob"
      };

      // Print the full URL
      const fullUrl = axios.getUri(config);
      console.log("Full request URL:", fullUrl);

      const response = await axios(config);

      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", `Transaction ${date} - ${endDate}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

    } catch (error) {
      console.error("Export failed", error);
    }
  };

  const renderTransactionList = () => {
    return filteredTransaksi.map((item, i) => {

      return (


        <tr className='' key={i}>
          {columns.map(({ accessor }) => {
            if (accessor === "booking_date") {
              return <td className="px-3 py-4 text-xs font-medium text-gray-800 whitespace-wrap" key={accessor}>{item.booking_times.length > 0 ? item.booking_times[0].booking_date : ""}</td>;
            } else if (accessor === "booking_time") {
              return <td className="px-3 py-4 text-xs font-medium text-gray-800 whitespace-wrap" key={accessor}>
                {item.booking_times.map((booking) => (
                  <div key={booking.booking_time}>{booking.booking_time}</div>
                ))}
              </td>;
            } else if (accessor != "status") {
              const tData = item[accessor] ? item[accessor] : "——";
              let ifNumeric = accessor == "total" ? numberFormat(tData) : tData

              return <td className="px-3 py-4 text-xs font-medium text-gray-800 whitespace-wrap" key={accessor}>{ifNumeric}</td>;

            } else {
              return (
                <td className="px-3 py-4 text-xs font-medium text-gray-800 whitespace-wrap" key={accessor}>

                  {item[accessor] == "paid" ?
                    <div className='bg-[#87c816] flex h-fit w-fit items-center rounded-lg  px-4 py-1.5 text-white font-semibold text-[10px]'>
                      LUNAS
                    </div>
                    : item[accessor] == "waiting_for_payment" ?
                      <div className='bg-[#ffaa00] flex h-fit w-fit items-center rounded-lg  px-4 py-1.5 text-white font-semibold text-[10px]'>
                        WAITING FOR PAYMENT
                      </div>
                      : item[accessor] == "waiting_confirmation" ?
                        <div className='bg-[#ffaa00] flex h-fit w-fit items-center rounded-lg  px-4 py-1.5 text-white font-semibold text-[10px]'>
                          WAITING CONFIRMATION
                        </div>
                        :
                        ["unpaid", "unpaid_dp"].includes(item[accessor]) ?
                          <div className='bg-[#ffaa00] flex h-fit w-fit items-center rounded-lg px-4 py-1.5 text-white font-semibold text-[9px]'>
                            BELUM DIBAYAR
                          </div>
                          :

                          item[accessor] == "cancel" ?
                            <div className='bg-[#ca4e4e] flex h-fit w-fit items-center rounded-lg px-4 py-1.5 text-white font-semibold text-[10px]'>
                              CANCEL
                            </div>
                            :

                            <div className='bg-[#ffaa00] flex h-fit w-fit items-center rounded-lg px-4 py-1.5 text-white font-semibold text-[10px]'>
                              {item[accessor]}
                            </div>
                  }


                </td>
              )
            }
          })}
          <td >
            <a href={'/transaction/' + item.id}>
              <button className='bg-primaryBlue px-4 py-2 text-[12px] font-semibold text-white rounded-lg'> Detail</button>
            </a>

          </td>
        </tr>
      )

    })
  }


  return (
    <div className=' w-full bg-white rounded-2xl flex flex-col px-6 py-6'>

      <div className='flex justify-between items-center '>


        <div className='flex items-center gap-x-6'>
          <p className='text-lg my-4 text-left text-gray-800 font-bold'>Daftar Transaksi</p>

          {/* search bar  */}
          <div className='flex items-center bg-gray-100 rounded-md w-[438px] p-1 h-fit'>
            <MagnifyingGlassIcon className='p-1 w-6 rounded-lg bg-gray-300 text-white' />
            <form onSubmit={(e) => { e.preventDefault(); handleQueryEnter() }} >
              <input value={query} onChange={(e) => { setQuery(e.target.value) }} type='text' className='text-xs w-full bg-transparent ml-4 focus:outline-none' placeholder='Cari transaksi, PIC Name atau Nama Lapang' />
            </form>
          </div>
        </div>

        <div className='flex flex-grow'></div>


        <div className='flex items-center justify-start bg-gray-200 rounded-md h-fit px-4 pr-1 text-xs  ml-4'>
          <select ref={selectRef} onChange={(e) => { filterTransactionStatus(e.target.value) }} className={"w-full appearance-none font-semibold text-gray-700 bg-transparent py-2"}>
            <option value="all">Semua</option>
            <option value="paid">Lunas</option>
            <option value="waiting_for_payment">Waiting for Payment</option>
            <option value="unpaid">Unpaid</option>
            <option value="cancel">Canceled</option>
          </select>
          <ChevronDownIcon
            className="text-white w-6 p-1 h-6 bg-primaryRed rounded-lg cursor-pointer"
            onClick={() => selectRef.current?.focus()} // Focus the select element
          />
        </div>


        <div className='flex items-center justify-start bg-gray-200 rounded-md h-fit px-4 pr-1 text-xs ml-4'>
          <input
            type="date"
            value={date || ""}
            onChange={(e) => {
              setDate(e.target.value)
            }}
            className='font-semibold text-gray-700 py-2 appearance-none  bg-gray-200 '
          />
          <XMarkIcon className='text-white w-6 p-1 h-6 bg-primaryRed rounded-lg ml-1' onClick={() => {
            setDate("")
          }} />
        </div>


        <div className='flex items-center justify-start bg-gray-200 rounded-md h-fit px-4 pr-1 text-xs ml-4'>
          <input
            type="date"
            value={endDate || ""}
            onChange={(e) => {
              setEndDate(e.target.value)
            }}
            className='font-semibold text-gray-700 py-2 appearance-none  bg-gray-200 '
          />
          <XMarkIcon className='text-white w-6 p-1 h-6 bg-primaryRed rounded-lg ml-1' onClick={() => {
            setEndDate("")
          }} />
        </div>

        <button className='bg-primaryRed px-4 py-2 text-[12px] font-semibold text-white rounded-lg ml-4' onClick={() => {
          exportDataToExcel();
        }}> EXPORT</button>



      </div>


      {transactionList.length > 0 ? (
        <>
          <table className='mt-4  '>

            <thead className="text-[12px] text-left text-[#343434]">
              <tr>

                {columns.map(({ label, accessor }) => {

                  return <th
                    onClick={() => handleSortingChange(accessor)}
                    key={accessor}
                    scope="col"
                    className="px-3 py-2 hover:cursor-pointer select-none text-xs font-bold text-left text-gray-700  "
                  >
                    <div className="flex items-center">
                      {label}

                      {
                        sortField === accessor && sortOrder === "asc"
                          ? <ArrowLongUpIcon className="h-3 w-3 ml-0.5 text-gray-700" />
                          : sortField === accessor && sortOrder === "desc"
                            ? <ArrowLongDownIcon className="h-3 w-3 ml-0.5 text-gray-700" />
                            : null
                      }
                    </div>

                  </th>

                })}
              </tr>
            </thead>

            <tbody className='divide-y divide-[#d8d8d8] text-gray-800'>
              {renderTransactionList()}
            </tbody>


          </table>
          {/* pagination  */}
          <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
            <div className="flex flex-1 justify-between sm:hidden">
              <button
                onClick={() => handleClickPage(Math.max(1, pagination.current_page - 1))}
                className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                disabled={pagination.current_page === 1}
              >
                Previous
              </button>
              <button
                onClick={() => handleClickPage(Math.min(pagination.total_pages, pagination.current_page + 1))}
                className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                disabled={pagination.current_page === pagination.total_pages}
              >
                Next
              </button>
            </div>
            <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
              <div>
                <p className="text-sm text-gray-700">
                  Showing <span className="font-medium">{(pagination.current_page - 1) * pagination.limit_value + 1}</span> to <span className="font-medium">{Math.min(pagination.current_page * pagination.limit_value, pagination.total_count)}</span> of <span className="font-medium">{pagination.total_count}</span> results
                </p>
              </div>
              <div>
                <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
                  <button
                    onClick={() => handleClickPage(pagination.current_page - 1)}
                    className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                    disabled={pagination.current_page === 1}
                  >
                    <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
                  </button>

                  {pagination.current_page > 2 && (
                    <button
                      onClick={() => handleClickPage(1)}
                      className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                    >
                      {1}
                    </button>
                  )}

                  {pagination.current_page > 2 && (
                    <span className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700">...</span>
                  )}


                  {pagination.current_page > 1 && (
                    <button
                      onClick={() => handleClickPage(pagination.current_page - 1)}
                      className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                    >
                      {pagination.current_page - 1}
                    </button>
                  )}

                  <span className="z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium">
                    {pagination.current_page}
                  </span>

                  {pagination.current_page < pagination.total_pages && (
                    <button
                      onClick={() => handleClickPage(pagination.current_page + 1)}
                      className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                    >
                      {pagination.current_page + 1}
                    </button>
                  )}

                  {pagination.current_page < pagination.total_pages - 1 && (
                    <span className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700">...</span>
                  )}

                  {pagination.current_page < pagination.total_pages - 1 && (
                    <button
                      onClick={() => handleClickPage(pagination.total_pages)}
                      className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                    >
                      {pagination.total_pages}
                    </button>
                  )}

                  <button
                    onClick={() => handleClickPage(pagination.current_page + 1)}
                    className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                    disabled={pagination.current_page === pagination.total_pages}
                  >
                    <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
                  </button>
                </nav>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="flex flex-1 flex-col items-center justify-center w-full border border-gray-200 rounded-lg overflow-hidden text-center px-4 py-6 text-sm text-gray-600">
          <img src="/il-empty-notransaction.png" alt="Empty State" className="w-[260px] mb-4" />
          <span className='text-[#898989] text-lg font-semibold mb-4'>Daftar Transaksi</span>
          <span className='text-[#898989]'>
            Tidak ada data yang ditampilkan karena belum ada transaksi dibuat oleh
            penyewa lapangan atau admin.<br />Admin dapat membuat transaksi secara manual.
          </span>
        </div>

      )}





    </div>
  );
}

export default TransactionList;